import Input from "@/components/FormComponents/Input";
import Button from "@mui/joy/Button";
import Grid from "@mui/joy/Grid";
import { useForm } from "react-hook-form";
import { getAgentAgencySchema, AgentAgencyType } from "./../schema/agentAgencyIDSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import axiosInstance from "@/services/api/axiosInstance";
import { useState } from "react";
import { toast } from "sonner";

interface Props {
  type: "agent" | "agency";
  mode: "create" | "update";
  onDataFetched: (data: any) => void;
}

const SearchComponent = ({ type, mode, onDataFetched }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AgentAgencyType>({
    resolver: zodResolver(getAgentAgencySchema(mode)),
    defaultValues: {
      agent: "",
    },
  });

  const handleSearch = async ({ agent }: AgentAgencyType) => {
    setIsSubmitting(true);
    try {
      if (mode === "update") {
        if (type === "agent") {
          const result = await axiosInstance.get(`/admin/constria/get-agent?agentId=${agent}`);
          onDataFetched(result.data.message);
          toast.success("Agent Found");
        }
        if (type === "agency") {
          const result = await axiosInstance.get(`/admin/constria/get-agency?agencyId=${agent}`);
          onDataFetched(result.data.message);
          toast.success("Agency Found");
        }
      }
      if (mode === "create") {
        const result = await axiosInstance.post("/admin/agent", {
          email: `${agent}@thetravelagentnextdoor.com`,
        });
        onDataFetched(result.data.message);
        toast.success(type === "agency" ? "Agency Found" : "Agent Found");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Something Went Wrong");
    }
    setIsSubmitting(false);
  };
  const placeHolder =
    mode === "create"
      ? type === "agent"
        ? "Agent Ex:John"
        : "Agent Ex:John"
      : type === "agent"
      ? "Agent ID"
      : "Agency ID";
  return (
    <form onSubmit={handleSubmit(handleSearch)}>
      <Grid
        container
        rowSpacing={4}
        columnSpacing={4}
        sx={{
          flex: "5 5 0%",
          mb: 4,
        }}
      >
        <Grid xs={4}>
          <Input
            placeholder={`Search with ${placeHolder}`}
            sx={{
              "&::placeholder": { fontSize: "10px" },
            }}
            error={errors.agent?.message}
            name="agent"
            register={register}
          />
        </Grid>
        <Grid xs={4} sx={{ display: "flex", alignItems: "center" }}>
          <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
            Search
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchComponent;
